import { useQuery } from 'react-query'
import { SharedDocumentInfoReponse } from '@dc-shared-web/hooks/api/document'
import { fetchSharedDocumentInfo } from '@dc-shared-web/hooks/api/document/fetchSharedDocumentInfo'

import { useAxiosContext } from '@dc-shared-web/providers/AxiosProvider'

export const useGetSharedDocumentInfo = (params: {
  onSuccess?: (data: SharedDocumentInfoReponse) => void
  uuid: string | undefined
}) => {
  const apiClient = useAxiosContext()

  return useQuery<SharedDocumentInfoReponse, Error>(
    ['sharedDocumentInfo', params],
    () => fetchSharedDocumentInfo(apiClient, params),
    {
      enabled: !!params.uuid,
      onSuccess: (data) => {
        params.onSuccess?.(data)
      },
    }
  )
}
